<ngx-loading [show]="loading"></ngx-loading>

<ng-container *ngIf="!is_ai_review_enabled">
<app-review-improvement
  *ngIf="feed_back === false && review_status == false"
></app-review-improvement>
<app-review-experience
  *ngIf="feed_back === true && review_status == false"
></app-review-experience>
<div class="container h-100 expiresec" *ngIf="review_status == true">
  <div class="row align-items-center h-100 expiresec">
    <div class="col-6 mx-auto">
      <div class="expiretext text-center">
        <h2 class="pb-3">Error!</h2>
        <img src="assets/gifs/exclamation-mark.png" width="80px" />
        <p class="pt-3">The link has expired</p>
      </div>
    </div>
  </div>
  <footer *ngIf="review_status == true && showPoweredBy">
    <div class="col-md-12 col-col-sm-12 col-xs-12">
      <div
        class="col-md-4 offset-md-4 col-sm-4 offset-sm-4 col-xs-12 thankyoureviewfooter"
      >
        <p>Powered by</p>
        <a
          href="https://www.zceppa.com/?utm_source=zceppa&utm_medium=consumer_link&utm_campaign=review_invite"
          target="_blank"
        >
          <img src="assets/images/zceppadark.svg" class="img-responsive" />
        </a>
      </div>
    </div>
  </footer>
</div>
</ng-container>

<ng-container *ngIf="isApiError == true">
  <div class="py-5 link-invalid-container">
    <div class="logo-container d-flex">
      <img class="logo" src="assets/images/linkoff-face.svg" alt="logo" />
    </div>
    <label class="link-invalid-label mt-4"
      >Uh oh! The link is currently unavailable</label
    >
  </div>
</ng-container>
